var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-grid__item m-grid__item--fluid m-wrapper"},[_c('div',{staticClass:"m-subheader"},[_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"mr-auto"},[_c('h3',{staticClass:"m-subheader__title"},[_vm._v("\n                    Welcome to Nantucket Admin\n                ")])])])])])
}]

export { render, staticRenderFns }